module.exports = __webpack_public_path__ + "img/woman.65fa2fe7.png";